import { h, render } from "preact";
import { AppConfig } from "./ts/types";

import parseAppConfigHTMLAttribute from "@common/helpers/parseAppConfigHTMLAttribute";
import Main from "./components/Main";

export default (appDOMNode: HTMLElement) => {
  const appConfig: AppConfig = parseAppConfigHTMLAttribute(appDOMNode);

  const renderedApp = render(<Main appConfig={appConfig} />, appDOMNode);

  return function disposeCallback() {
    render("", appDOMNode, renderedApp);
  };
};
